import React from "react";
import toolkitImage from "./ocd-complete-therapy-toolkit.png";
import exposureImage from "./exposure-image.png";

const TOOLKIT_URL =
  "https://play.google.com/store/apps/details?id=com.olivier7355.ocdserenitymobile";
const ERP_URL =
  "https://play.google.com/store/apps/details?id=com.ocdserenity.exposurehierarchy";

const featureRow = {
  textAlign: "left",
  margin: "8px 0",
  color: "#ffffff",
};

const downloadBtn = (bg) => ({
  display: "inline-block",
  backgroundColor: bg,
  color: "white",
  padding: "15px 25px",
  borderRadius: "25px",
  textDecoration: "none",
  fontWeight: "bold",
  fontSize: "16px",
  marginTop: "20px",
  transition: "all 0.3s ease",
});

const MobileApps = () => {
  return (
    <section style={{ maxWidth: "1000px", margin: "40px auto", textAlign: "center" }}>
      <h2 style={{ color: "#ffffff", marginBottom: "10px" }}>
        🚀 Get Our Two Free OCD Apps
      </h2>
      <p
        style={{
          color: "#cccccc",
          fontSize: "18px",
          maxWidth: "700px",
          margin: "0 auto 30px auto",
        }}
      >
        Download both to support your recovery — daily tracking with the Complete
        Toolkit, and ERP exposure work with the Hierarchy Builder. They work
        perfectly together.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "30px",
        }}
      >
        {/* App 1 - Toolkit */}
        <div
          style={{
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            textAlign: "center",
            border: "3px solid #007bff",
          }}
        >
          <div
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "20px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            MOST POPULAR
          </div>
          <h3 style={{ color: "#007bff", marginBottom: "20px" }}>
            <strong>🧰 OCD Complete Therapy Toolkit</strong>
          </h3>
          <a href={TOOLKIT_URL} target="_blank" rel="noopener noreferrer">
            <img
              src={toolkitImage}
              alt="OCD Complete Therapy Toolkit App"
              style={{
                maxWidth: "100%",
                display: "block",
                height: "auto",
                borderRadius: "15px",
                margin: "20px auto",
                boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              }}
            />
          </a>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              marginBottom: "20px",
              color: "#ffffff",
            }}
          >
            <strong>Your complete OCD management suite!</strong> Track symptoms,
            access evidence-based resources, and monitor your progress with
            comprehensive analytics.
          </p>

          <div style={{ margin: "20px 0", padding: "0 10px" }}>
            <p style={featureRow}>
              <strong>✅ Symptom/trigger tracking</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ Evidence-based resources</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ Progress visualization</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ Therapeutic exercises</strong>
            </p>
          </div>

          <a
            href={TOOLKIT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={downloadBtn("#007bff")}
          >
            📱 Download FREE on Google Play
          </a>

          {/* QR Code */}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <p style={{ fontSize: "14px", marginBottom: "10px", color: "#cccccc" }}>
              📱 Scan with your phone:
            </p>
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${TOOLKIT_URL}`}
              alt="QR Code for OCD Complete Therapy Toolkit"
              style={{
                width: "120px",
                height: "120px",
                border: "2px solid #007bff",
                borderRadius: "10px",
                padding: "5px",
                backgroundColor: "white",
              }}
            />
          </div>
        </div>

        {/* App 2 - ERP */}
        <div
          style={{
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            textAlign: "center",
            border: "2px solid #28a745",
          }}
        >
          <div
            style={{
              backgroundColor: "#28a745",
              color: "white",
              padding: "10px 20px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "20px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            ERP SPECIALIST
          </div>
          <h3 style={{ color: "#28a745", marginBottom: "20px" }}>
            <strong>📊 Exposure Hierarchy Builder</strong>
          </h3>
          <a href={ERP_URL} target="_blank" rel="noopener noreferrer">
            <img
              src={exposureImage}
              alt="OCD Exposure Hierarchy Builder App"
              style={{
                maxWidth: "100%",
                display: "block",
                height: "auto",
                borderRadius: "15px",
                margin: "20px auto",
                boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              }}
            />
          </a>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              marginBottom: "20px",
              color: "#ffffff",
            }}
          >
            <strong>Perfect for ERP therapy!</strong> Build custom exposure
            hierarchies, track SUDS levels, and monitor your progress through
            graduated exposures.
          </p>

          <div style={{ margin: "20px 0", padding: "0 10px" }}>
            <p style={featureRow}>
              <strong>✅ Custom exposures</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ SUDS level tracking</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ Progress monitoring</strong>
            </p>
            <p style={featureRow}>
              <strong>✅ Therapist collaboration</strong>
            </p>
          </div>

          <a
            href={ERP_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={downloadBtn("#28a745")}
          >
            📊 Download FREE on Google Play
          </a>

          {/* QR Code */}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <p style={{ fontSize: "14px", marginBottom: "10px", color: "#cccccc" }}>
              📱 Scan with your phone:
            </p>
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${ERP_URL}`}
              alt="QR Code for OCD Exposure Hierarchy Builder"
              style={{
                width: "120px",
                height: "120px",
                border: "2px solid #28a745",
                borderRadius: "10px",
                padding: "5px",
                backgroundColor: "white",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileApps;